import ChatWidget from './widget.js';

const bootChatWidgets = () => {
    document.querySelectorAll('[data-chat-widget]').forEach((el) => {
        new ChatWidget(el);
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootChatWidgets, { once: true });
} else {
    bootChatWidgets();
}
